import { jwtDecode } from "jwt-decode";

const AUTH_TOKEN_KEY = "authToken";
const LOGIN_REQUIRED_KEY = "loginRequired";
const EXPIRY_SKEW_SECONDS = 30;

let authTokenProvider = null;

export const getStoredAuthToken = () =>
  localStorage.getItem(AUTH_TOKEN_KEY) || "";

export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const exp = decoded?.exp;
    if (!exp) return false;
    const now = Math.floor(Date.now() / 1000);
    return exp <= now + EXPIRY_SKEW_SECONDS;
  } catch (error) {
    return true;
  }
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.setItem(LOGIN_REQUIRED_KEY, "true");
};

export const getAuthHeader = () => {
  const token = getStoredAuthToken();
  if (!token) return null;
  if (isTokenExpired(token)) {
    clearAuthToken();
    return null;
  }
  return `Bearer ${token}`;
};

export const setAuthTokenProvider = (provider) => {
  authTokenProvider = provider;
};

export const refreshAuthToken = async () => {
  if (!authTokenProvider) return "";
  try {
    const token = await authTokenProvider();
    if (token) {
      localStorage.setItem(AUTH_TOKEN_KEY, token);
    }
    return token || "";
  } catch (error) {
    clearAuthToken();
    return "";
  }
};
